import React, { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const StateContext = ({ children }) => {
  const [language, setLanguage] = useState(true);
  const [loading, setLoading] = useState(true);
  //Changing Color Theme
  const switchLanguageHandler = () => {
    setLanguage(!language);
  };

  return (
    <GlobalContext.Provider
      value={{
        language,
        setLanguage,
        switchLanguageHandler,
        loading,
        setLoading,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useStateContext = () => useContext(GlobalContext);
